import { render, staticRenderFns } from "./NQR.vue?vue&type=template&id=7f60f6d2&scoped=true"
import script from "./NQR.vue?vue&type=script&lang=js"
export * from "./NQR.vue?vue&type=script&lang=js"
import style0 from "./NQR.vue?vue&type=style&index=0&id=7f60f6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f60f6d2",
  null
  
)

export default component.exports